import 'css-chunksrc/client/pages/projectPage/timeSheetPage/loader/allocation/list/task/styles.scss';export default {
  "main": "_main_1pjn0_1",
  "header": "_header_1pjn0_7",
  "iconBox": "_iconBox_1pjn0_18",
  "icon": "_icon_1pjn0_18",
  "openedIcon": "_openedIcon_1pjn0_34",
  "row": "_row_1pjn0_38",
  "avatar": "_avatar_1pjn0_45",
  "col": "_col_1pjn0_50",
  "name": "_name_1pjn0_59",
  "profession": "_profession_1pjn0_64",
  "recordList": "_recordList_1pjn0_69"
};